document.addEventListener('DOMContentLoaded', () => {
  const getHeaderOffset = () => {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const tutorialNav = document.querySelector('.tutorials-page__nav-wrap');
    const headerHeight = headerGroup ? headerGroup.getBoundingClientRect().height : 0;
    const navPosition = tutorialNav ? window.getComputedStyle(tutorialNav).position : '';
    const navHeight = tutorialNav && (navPosition === 'sticky' || navPosition === 'fixed') ? tutorialNav.getBoundingClientRect().height : 0;

    return Math.round(headerHeight + navHeight + 28);
  };

  const getTutorialTarget = (targetId) => {
    if (!targetId || targetId.charAt(0) !== '#') return null;

    return document.getElementById(decodeURIComponent(targetId.slice(1)));
  };

  const setPageScroll = (top, behavior) => {
    const safeTop = Math.max(0, top);
    const scroller = document.scrollingElement || document.documentElement || document.body;
    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;

    if (typeof window.scrollTo === 'function') {
      if (behavior === 'smooth' && window.scrollY < 5 && safeTop > 5) {
        root.style.scrollBehavior = 'auto';
        window.scrollTo({ top: 6, behavior: 'auto' });

        window.setTimeout(() => {
          root.style.scrollBehavior = previousScrollBehavior;
          window.scrollTo({ top: safeTop, behavior: 'smooth' });
        }, 0);

        return;
      }

      if (behavior !== 'smooth') {
        root.style.scrollBehavior = 'auto';
      }

      window.scrollTo({ top: safeTop, behavior });

      if (behavior !== 'smooth') {
        window.setTimeout(() => {
          root.style.scrollBehavior = previousScrollBehavior;
        }, 0);
      }

      return;
    }

    if (behavior !== 'smooth') {
      scroller.scrollTop = safeTop;
      return;
    }

    const startTop = scroller.scrollTop;
    const distance = safeTop - startTop;
    const duration = 520;
    const startTime = window.performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);

      scroller.scrollTop = startTop + (distance * eased);

      if (progress < 1) {
        window.requestAnimationFrame(animate);
      }
    };

    window.requestAnimationFrame(animate);
  };

  const scrollToTutorialSection = (targetId, behavior = 'smooth') => {
    const target = getTutorialTarget(targetId);

    if (!target) return;

    const baseUrl = `${window.location.pathname}${window.location.search}`;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    if (window.location.hash === targetId) {
      history.replaceState(null, '', baseUrl);
    }

    setPageScroll(targetTop, behavior);

    setActiveTutorialLink(targetId);
    history.pushState(null, '', targetId);
  };

  const ensureTutorialSectionVisible = (targetId) => {
    const target = getTutorialTarget(targetId);

    if (!target) return;

    const headerOffset = getHeaderOffset();
    const targetTop = target.getBoundingClientRect().top;
    const isNicelyVisible = targetTop >= headerOffset - 36 && targetTop <= headerOffset + 96;

    if (!isNicelyVisible) {
      scrollToTutorialSection(targetId, 'auto');
    }
  };

  const setActiveTutorialLink = (targetId) => {
    document.querySelectorAll('.tutorial-anchor-nav a[href^="#"]').forEach((link) => {
      const isActive = link.getAttribute('href') === targetId;

      link.classList.toggle('is-active', isActive);
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const initTutorialAnchors = () => {
    if (document.documentElement.dataset.tutorialAnchorsInitialized === 'true') return;
    document.documentElement.dataset.tutorialAnchorsInitialized = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.tutorial-anchor-nav a[href^="#"]');

      if (!link) return;

      const targetId = link.getAttribute('href');

      if (!targetId || targetId === '#') return;

      event.preventDefault();
      scrollToTutorialSection(targetId);
    }, true);
  };

  const initTutorialCarousels = (scope = document) => {
    scope.querySelectorAll('[data-tutorials-carousel]').forEach((carousel) => {
      if (carousel.dataset.tutorialsInitialized === 'true') return;
      carousel.dataset.tutorialsInitialized = 'true';

      const track = carousel.querySelector('[data-tutorials-track]');
      const slides = [...carousel.querySelectorAll('[data-tutorials-slide]')];
      const dots = [...carousel.querySelectorAll('[data-tutorials-dot]')];
      const previous = carousel.querySelector('[data-tutorials-prev]');
      const next = carousel.querySelector('[data-tutorials-next]');

      if (!track || slides.length === 0) return;

      const scrollToIndex = (index) => {
        const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
      };

      const getIndex = () => {
        const width = track.clientWidth || 1;
        return Math.round(track.scrollLeft / width);
      };

      const updateDots = () => {
        const activeIndex = getIndex();
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      };

      previous?.addEventListener('click', () => scrollToIndex(getIndex() - 1));
      next?.addEventListener('click', () => scrollToIndex(getIndex() + 1));

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => scrollToIndex(index));
      });

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateDots);
      }, { passive: true });

      updateDots();
    });
  };

  initTutorialAnchors();
  initTutorialCarousels();

  window.addEventListener('hashchange', () => {
    if (window.location.hash && getTutorialTarget(window.location.hash)) {
      scrollToTutorialSection(window.location.hash);
    }
  });

  if (window.location.hash && getTutorialTarget(window.location.hash)) {
    setActiveTutorialLink(window.location.hash);
    window.setTimeout(() => scrollToTutorialSection(window.location.hash), 120);
  } else {
    setActiveTutorialLink('#sizing');
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTutorialCarousels(event.target);
  });
});
